module.exports = __webpack_public_path__ + "img/FE_A4_back_en.59c8b463.png";